import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from "recharts";
import { PILLARS } from "@/constants";

export default function PillarRadar({ pillars, color = "#0033AD" }) {
  const data = PILLARS.map((p) => ({ pilar: p.label, valor: pillars?.[p.key] ?? 0 }));
  return (
    <div style={{ width: "100%", height: 320 }}>
      <ResponsiveContainer width="100%" height={320} minWidth={200} minHeight={160} initialDimension={{ width: 520, height: 320 }}>
        <RadarChart data={data} outerRadius="78%">
          <PolarGrid stroke="#D9CFB9" />
          <PolarAngleAxis dataKey="pilar" tick={{ fill: "#11142B", fontSize: 12, fontWeight: 600 }} />
          <PolarRadiusAxis angle={90} domain={[0, 10]} tick={{ fill: "#7C7560", fontSize: 10 }} />
          <Radar name="Calificación" dataKey="valor" stroke={color} fill={color} fillOpacity={0.25} strokeWidth={2} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
